import graphQLClient from 'config/graphql-instance';
import { gql } from 'graphql-request';
import { AccountingFilter, Proration } from 'v2-types/order';

export const prorationsQuery = gql`
  prorations {
    _id
    accounting {
      _id
      amount
      code
      description
    }
    days
    days_year
    debited_party
    decimals
    end_date
    description
    start_date
    type
    schedule
    proration_date
    paid_thru
    next_due
    kind
    include_1099
    impound_disclosure
    estate {
      _id
      address {
        address
      }
    }
  }
  accounting {
    _id
  }
  estates {
    _id
  }
`;

type GetProrationsParams = {
  orderId: string,
  filters?: { [key: string]: AccountingFilter };
}

export type GetProrationsReturn = {
  getOrder: {
    prorations: Proration[]
  }
}

export const getProrations = async (payload: GetProrationsParams) => {
  const query = gql`
  query GetOrder($orderId: ID!, $filters: OrderFilters) {
    getOrder(_id: $orderId, filters: $filters) {
      ${prorationsQuery}
    }
  }
  `;
  const response = await graphQLClient().request<GetProrationsReturn, GetProrationsParams>(query, {
    ...payload,
    filters: {
      accounting: "/proration_(amount|perdiem|prorated)_/"
    }
  });
  return response;
};
